import { render, staticRenderFns } from "./GalaxyWizard.vue?vue&type=template&id=b11d8ecc&scoped=true"
import script from "./GalaxyWizard.vue?vue&type=script&setup=true&lang=ts"
export * from "./GalaxyWizard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GalaxyWizard.vue?vue&type=style&index=0&id=b11d8ecc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11d8ecc",
  null
  
)

export default component.exports